module.exports = __webpack_public_path__ + "static/media/list-solid.9088ba6e.svg";